import React, { useMemo } from "react";

// Gráfica del CIMAX de cada modo a lo largo del tiempo (una línea por modo).
export const PROGRESS_LINES = [
  { field: "ciencia", label: "Ciencia", color: "#3f86f4" },
  { field: "cienzar", label: "Cienzar", color: "#2ca65a" },
  { field: "sciencevsazar", label: "Contrazar", color: "#e5484d" },
  { field: "azar", label: "Azar", color: "#e8892e" },
];

const WIDTH = 900;
const HEIGHT = 120;
const PAD = { left: 40, right: 10, top: 8, bottom: 18 };

const formatDay = (ms) =>
  new Date(ms).toLocaleDateString("es-ES", { day: "numeric", month: "short" });

const HistoryProgressChart = ({ series = {}, hidden = {} }) => {
  const geometry = useMemo(() => {
    const visible = PROGRESS_LINES.filter((line) => !hidden[line.field] && (series[line.field] || []).length);
    const points = visible.flatMap((line) => series[line.field]);
    if (!points.length) return null;
    const minT = Math.min(...points.map((point) => point.t));
    const maxT = Math.max(...points.map((point) => point.t));
    let minV = Math.min(...points.map((point) => point.v));
    let maxV = Math.max(...points.map((point) => point.v));
    const margin = Math.max(20, (maxV - minV) * 0.08);
    minV -= margin;
    maxV += margin;
    const x = (t) => PAD.left + ((t - minT) / Math.max(1, maxT - minT)) * (WIDTH - PAD.left - PAD.right);
    const y = (v) => PAD.top + (1 - (v - minV) / Math.max(1, maxV - minV)) * (HEIGHT - PAD.top - PAD.bottom);
    const ticks = Array.from({ length: 3 }, (_, index) => minV + ((maxV - minV) * index) / 2);
    return {
      minT,
      maxT,
      ticks: ticks.map((value) => ({ value: Math.round(value), y: y(value) })),
      lines: visible.map((line) => ({
        ...line,
        d: series[line.field]
          .map((point, index) => `${index ? "L" : "M"}${x(point.t).toFixed(1)},${y(point.v).toFixed(1)}`)
          .join(" "),
        last: series[line.field][series[line.field].length - 1],
        lastX: x(series[line.field][series[line.field].length - 1].t),
        lastY: y(series[line.field][series[line.field].length - 1].v),
      })),
    };
  }, [hidden, series]);

  if (!geometry) {
    return <div className="xhm-chart-empty">Todavía no hay partidas con CIMAX en este periodo.</div>;
  }
  return (
    <svg className="xhm-chart" viewBox={`0 0 ${WIDTH} ${HEIGHT}`} role="img" aria-label="Progreso de CIMAX por modo">
      {geometry.ticks.map((tick) => (
        <g key={tick.y}>
          <line x1={PAD.left} x2={WIDTH - PAD.right} y1={tick.y} y2={tick.y} className="xhm-chart-grid" />
          <text x={PAD.left - 8} y={tick.y + 4} textAnchor="end" className="xhm-chart-label">
            {tick.value}
          </text>
        </g>
      ))}
      <text x={PAD.left} y={HEIGHT - 6} className="xhm-chart-label">{formatDay(geometry.minT)}</text>
      <text x={WIDTH - PAD.right} y={HEIGHT - 6} textAnchor="end" className="xhm-chart-label">Hoy</text>
      {geometry.lines.map((line) => (
        <g key={line.field}>
          <path d={line.d} fill="none" stroke={line.color} strokeWidth="2.6" strokeLinejoin="round" strokeLinecap="round" />
          <circle cx={line.lastX} cy={line.lastY} r="4.5" fill={line.color} />
        </g>
      ))}
    </svg>
  );
};

export default HistoryProgressChart;
